<template>
  <div>
    <form @submit.prevent="onEnter" v-if="loggedIn && completedLogin">
      <div class=" flex rounded-md shadow-sm">
        <textarea
          v-model="comment"
          id="about"
          rows="3"
          class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        ></textarea>
      </div>
      <div class="mt-2">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="submit"
            class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md
           text-white text-xl tracking-wide bg-darkpurple font-bebas hover:bg-peach focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
          :disabled="isDisabled"
          >
            Post
          </button>
        </span>
      </div>
    </form>
    <div class="mt-6 overflow-y-scroll" style="max-height: 500px">
      <comment
        :comment="comment"
        v-for="(comment, idx) in comments"
        :key="idx"
        :index="idx"
        v-on:remove-comment="handleRemoveComment"
      ></comment>
    </div>
    <if-can-take-part
      login-class="border border-purple shadow"
    ></if-can-take-part>
  </div>
</template>

<script>
import { projectsCollection, auth, firebase } from "../utils/firebase";
import { mapGetters } from "vuex";
import Comment from "./Comment";
import { removeProjectComment } from "../utils/functions";
import IfCanTakePart from "./IfCanTakePart";

export default {
  name: "ProjectCommentArea",
  components: { IfCanTakePart, Comment },
  props: {
    documentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      commentsCollection: null,
      comment: "",
      comments: [],
      unsubscribe: null
    };
  },
  computed: {
    ...mapGetters(["loggedIn", "completedLogin"]),
    isDisabled() {
      return this.comment === undefined || this.comment == null || this.comment.trim().length == 0;
    }
  },
  methods: {
    handleRemoveComment(commentID) {
      this.$store.dispatch("setDeletedMessageId", commentID);
      removeProjectComment(this.documentId, commentID);
    },
    onEnter() {
      // submit the message
      this.commentsCollection
        .add({
          topic: this.documentId,
          body: this.comment,
          user: auth.currentUser.uid,
          userDisplay: auth.currentUser.displayName,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(docRef => console.log("Document written with ID: ", docRef.id))
        .catch(error => console.error("Error adding a document", error));
      this.comment = "";
    },
    fetchComments() {
      const vm = this;
      vm.comments = [];
      this.unsubscribe = this.commentsCollection
        .orderBy("timestamp")
        .where("topic", "==", this.documentId)
        .onSnapshot(function(querySnapshot) {
          querySnapshot.docChanges().forEach(change => {
            let doc = change.doc;
            if (change.type === "added") {
              vm.comments.push({ id: doc.id, ...doc.data() });
            }
            if (change.type === "modified") {
              const index = vm.comments.findIndex(
                item => item.id === change.doc.id
              );
              vm.comments.splice(index, 1, { id: doc.id, ...doc.data() });
            }

            if (change.type === "removed") {
              const index = vm.comments.findIndex(
                item => item.id === change.doc.id
              );
              vm.comments.splice(index, 1);
            }
          });
        });
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  created() {
    this.commentsCollection = projectsCollection
      .doc(this.documentId)
      .collection("comments");
    this.fetchComments();
  }
};
</script>

<style scoped></style>
